import React from "react";
import { ArrowUp } from "lucide-react";
import { profile, socials } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[var(--ink)] text-[#FAFAF7]">
      <div className="container-wide py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="section-label !text-[#FAFAF7]/50">Get in touch</p>
            <a
              href={`mailto:${profile.email}`}
              className="block font-serif-display font-light text-[clamp(1.25rem,4vw,2.75rem)] mt-4 tracking-[0.015em] break-words hover:text-[var(--accent-soft)] transition-colors"
            >
              {/* <wbr> lets a long address wrap after the "@" rather than mid-word. */}
              {profile.email.split("@")[0]}@<wbr />
              {profile.email.split("@")[1]}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="section-label !text-[#FAFAF7]/50 mb-4">Elsewhere</p>
            <ul className="space-y-2.5">
              {socials.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[15px] text-[#FAFAF7]/80 link-underline hover:text-[#FAFAF7]"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="section-label !text-[#FAFAF7]/50 mb-4">Studio</p>
            <p className="text-[15px] text-[#FAFAF7]/80">{profile.location}</p>
            <p className="text-[15px] text-[#FAFAF7]/80 mt-1">{profile.role}</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mt-16 pt-8 border-t border-white/10">
          <p className="text-[13px] text-[#FAFAF7]/50">
            &copy; {new Date().getFullYear()} {profile.name}. All rights reserved.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group inline-flex items-center gap-2 text-[13px] text-[#FAFAF7]/70 hover:text-[#FAFAF7] transition-colors"
          >
            Back to top
            <span className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#FAFAF7] group-hover:text-[var(--ink)] transition-colors">
              <ArrowUp size={15} />
            </span>
          </button>
        </div>
      </div>
    </footer>
  );
}
